(function () {
  function initSlider(slider) {
    var handle = slider.querySelector('[data-malcriados-handle]');
    if (!handle) return;

    var isDragging = false;

    function setPosition(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      var pct = (x / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      slider.style.setProperty('--slider-position', pct + '%');
    }

    function onPointerDown(e) {
      isDragging = true;
      slider.classList.add('is-dragging');
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
      e.preventDefault();
      e.stopPropagation();
    }

    function onPointerMove(e) {
      if (!isDragging) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
      // Solo prevenir scroll vertical mientras el usuario está activamente arrastrando el handle
      if (e.cancelable) e.preventDefault();
    }

    function onPointerUp() {
      isDragging = false;
      slider.classList.remove('is-dragging');
    }

    // Solo el HANDLE inicia drag (no el slider entero) — para no robar scroll vertical mobile
    handle.addEventListener('mousedown', onPointerDown);
    handle.addEventListener('touchstart', onPointerDown, { passive: false });

    // Mientras se arrastra, escuchamos en window para no perder eventos al salir del handle
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('touchend', onPointerUp);
    window.addEventListener('touchcancel', onPointerUp);

    // Teclado para accesibilidad: flechas
    handle.addEventListener('keydown', function (e) {
      var current = parseFloat(slider.style.getPropertyValue('--slider-position')) || 50;
      var step = e.shiftKey ? 10 : 5;
      if (e.key === 'ArrowLeft') {
        slider.style.setProperty('--slider-position', Math.max(0, current - step) + '%');
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        slider.style.setProperty('--slider-position', Math.min(100, current + step) + '%');
        e.preventDefault();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-malcriados-antes-despues]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
